import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=74c2d48c&scoped=true&"
import script from "./NotesList.vue?vue&type=script&lang=js&"
export * from "./NotesList.vue?vue&type=script&lang=js&"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=74c2d48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2d48c",
  null
  
)

export default component.exports